import { render, staticRenderFns } from "./BoryNoveBloky.vue?vue&type=template&id=ac37e846&scoped=true"
import script from "./BoryNoveBloky.vue?vue&type=script&lang=js"
export * from "./BoryNoveBloky.vue?vue&type=script&lang=js"
import style0 from "./BoryNoveBloky.vue?vue&type=style&index=0&id=ac37e846&prod&lang=sass&scoped=true"
import style1 from "./BoryNoveBloky.vue?vue&type=style&index=1&id=ac37e846&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac37e846",
  null
  
)

export default component.exports